import { render, staticRenderFns } from "./CobrancaEdicaoModal.vue?vue&type=template&id=65feb4a4&scoped=true"
import script from "./CobrancaEdicaoModal.vue?vue&type=script&lang=js"
export * from "./CobrancaEdicaoModal.vue?vue&type=script&lang=js"
import style0 from "./CobrancaEdicaoModal.vue?vue&type=style&index=0&id=65feb4a4&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65feb4a4",
  null
  
)

export default component.exports